module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./zh-WUU-HANS.coffee"));
	}, "locale/zh-WUU-HANS");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/zh-WUU-HANS.coffee
// module id = 310
// module chunks = 97